import { Partnership } from '@/models/partnership';

import { Event } from './event';

export class PartnershipSelectedEvent extends Event<Partnership> {}
